import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route } from '@angular/router';
import { AuthGuard } from '../../auth.guard';
import { SharedModule } from '../../shared/shared.module';

/**
 * CTWR
 */
import { CtwrComponent } from './ctwr.component';
import { RequestComponent } from './request/request.component';
import { ToolingComponent } from './request/tooling-components/tooling.component';
import { DetailComponent } from './request/detail/detail.component';

/**
* Administration
*/
import { AdministrationComponent } from './administration/administration.component';

//  Security
import { RolesComponent } from './administration/security/roles/roles.component';
import { UsersComponent } from './administration/security/users/users.component';

// Maintenance
import { PartsComponent } from './administration/maintenance/parts/parts.component';
import { PartTypesComponent } from './administration/maintenance/part-types/part-types.component';
import { PartFamilesComponent } from './administration/maintenance/part-familes/part-familes.component';
import { ProcessesComponent } from './administration/maintenance/processes/processes.component';
import { ItemsComponent } from './administration/maintenance/items/items.component';
import { ComponentComponent } from './administration/maintenance/component/component.component';
import { ComponentCategoryComponent } from './administration/maintenance/component-category/component-category.component';
import { LocationsComponent } from './administration/maintenance/locations/locations.component';
import { ProgramsComponent } from './administration/maintenance/programs/programs.component';
import { DesignPhasesComponent } from './administration/maintenance/design-phases/design-phases.component';

import {
  CtwrUserService,
  CtwrPartService,
  CtwrPartTypeService,
  CtwrLocationService,
  CtwrProcessService,
  CtwrProgramService,
  CtwrPartFamilyService,
  CtwrComponentCategoryService,
  CtwrItemService,
  CtwrComponentService,
  CtwrDesignPhaseService,
  CtwrLocationApproverService,
  CtwrAuthorizationTypeService,
  CtwrRequestService
} from './ctwr.service';


import { NavToolbarService } from '../../shared/nav-toolbar/nav-toolbar.service';
import { PartSearchComponent } from './request/part-search/part-search.component';
import { RequestService } from './request/request.service';
import { RequestDetailService } from './request/detail/detail.service';
import { S3Service } from '../../shared/services/s3.service';
import { ReportingComponent } from './reporting/reporting.component';
import { SignalrService } from './signalr.service';
import { AuditLogComponent } from './administration/maintenance/audit-log/audit-log.component';
import { SummaryComponent } from './reporting/summary/summary.component';
import { PartOwnershipComponent } from './administration/maintenance/parts/part-ownership/part-ownership.component';
import { RequestManagementComponent } from './administration/maintenance/request-management/request-management.component';
export const ctwrRoutes: Route = {
  path: 'CTWR',
  component: CtwrComponent,
  canActivate: [AuthGuard],
  data: { breadcrumb: "CTWR" },
  children: [
    {
      path: 'Administration',
      component: AdministrationComponent,
      canActivate: [AuthGuard],
      data: { breadcrumb: "Administration" },
      children: [
        // Maintenance
        {
          path: 'Parts',
          component: PartsComponent,
          data: { breadcrumb: "Parts" }
        },
        {
          path: 'Part-types',
          component: PartTypesComponent,
          data: { breadcrumb: "Part Types" }
        },
        {
          path: 'Part-families',
          component: PartFamilesComponent,
          data: { breadcrumb: "Part Families" }
        },
        {
          path: 'Locations',
          component: LocationsComponent,
          data: { breadcrumb: "Locations" }
        },
        {
          path: 'Processes',
          component: ProcessesComponent,
          data: { breadcrumb: "Processes" }
        },
        {
          path: 'Categories',
          component: ComponentCategoryComponent,
          data: { breadcrumb: "Categories" }
        },

        {
          path: 'Items-Names',
          component: ComponentComponent,
          data: { breadcrumb: "Item Names" }
        },
        {
          path: 'Item-Descriptions',
          component: ItemsComponent,
          data: { breadcrumb: "Item Descriptions" }
        },
        {
          path: 'Programs',
          component: ProgramsComponent,
          data: { breadcrumb: "Programs" }
        },
        {
          path: 'Design-phases',
          component: DesignPhasesComponent,
          data: { breadcrumb: "Design Phases" }
        },
        {
          path: 'Audit-log',
          component: AuditLogComponent,
          data: { breadcrumb: "Audit Log" }
        },
        {
          path: 'Request-Management',
          component: RequestManagementComponent,
          data: { breadcrumb: "Request Management" }
        },
        // Security
        {
          path: 'Users',
          data: { breadcrumb: "Users" },
          component: UsersComponent,
        },
        {
          path: 'Roles',
          data: { breadcrumb: "Roles" },
          component: RolesComponent,
        },
      ]
    },
    {
      path: 'Requests',
      data: { breadcrumb: "Requests" },
      component: RequestComponent,
    },
    {
      path: 'Reporting',
      data: { breadcrumb: "Reporting" },
      component: ReportingComponent,
    },
    {
      path: 'Detail/:id',
      data: { breadcrumb: "Detail" },
      component: DetailComponent,
    },
  ]
}


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
  ],
  declarations: [
    CtwrComponent,
    AdministrationComponent,
    RolesComponent,
    PartTypesComponent,
    ProcessesComponent,
    RequestComponent,
    DetailComponent,
    PartsComponent,
    LocationsComponent,
    ProgramsComponent,
    DesignPhasesComponent,
    UsersComponent,
    PartFamilesComponent,
    ItemsComponent,
    ComponentCategoryComponent,
    ComponentComponent,
    ReportingComponent,
    AuditLogComponent,
    SummaryComponent,
    PartOwnershipComponent,
    RequestManagementComponent
  ],
  providers: [
    CtwrUserService,
    CtwrPartService,
    CtwrPartTypeService,
    CtwrPartFamilyService,
    CtwrLocationService,
    CtwrLocationApproverService,
    CtwrProcessService,
    CtwrProgramService,
    CtwrComponentCategoryService,
    CtwrComponentService,
    CtwrItemService,
    CtwrDesignPhaseService,
    NavToolbarService,
    RequestService,
    CtwrRequestService,
    CtwrAuthorizationTypeService,
    RequestDetailService,
    ToolingComponent,
    PartSearchComponent,

    // Workflow Services
    S3Service,
    SignalrService,
  ]
})
export class CtwrModule { }
